<template>
  <div>
    <PageLoader v-bind:storage="appLoading" v-bind:contain="true" />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showSnackBar" color="#3EA56E" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap justify-center>
      <v-flex xs12 px-0 px-sm-4 pt-4>
        <v-layout wrap justify-center>
          <v-flex xs10 sm12 xl12 text-left text-uppercase>
            <span
              style="
                font-family: poppinssemibold;
                font-size: 16px;
                color: #000000;
                letter-spacing: 1px;
              "
            >
              Wishlist
            </span>
          </v-flex>
        </v-layout>
        <v-layout wrap justify-start v-if="products.length > 0">
          <v-flex
            xs6
            sm4
            md4
            lg4
            xl3
            pa-2
            v-for="(item, i) in products"
            :key="i"
            text-left
          >
            <WishlistItem
              v-bind:storage="item"
              v-bind:cardWidth="'250px'"
              @stepper="winStepper"
            />
          </v-flex>
        </v-layout>
        <v-layout wrap justify-center v-else>
          <v-flex xs12 pa-2 align-self-center>
            <span
              style="
                font-family: poppinsregular;
                font-size: 25px;
                color: #000000;
                cursor: pointer;
              "
              >Oops! No Products Found</span
            >
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
import WishlistItem from "./wishlistItem";
export default {
  components: {
    WishlistItem,
  },
  data() {
    return {
      appLoading: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,
      products: [],
      ServerError: false,
    };
  },
  beforeMount() {
    this.getData();
  },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/WishList/all",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.products = response.data.wishlist;
          } else {
            this.products = [];
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    winStepper(item) {
      if (item.ref == "remove") {
        this.msg = item.response.msg;
        this.showSnackBar = true;
        if (item.getData) {
          this.getData();
        }
      }
    },
  },
};
</script>